import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    contratos: [],
    contratoAtual: {},
    badge: 0,
    personificado: false,
    exibirStatusObra: false,
    exibirPersonalizacao: false,
    nome: '',
    email: '',
    documento: '',
    codigoCliente: '',
    codigoUsuario: '',
    conjugeCPF: '',
    conjugeNome: '',
    headerType: 'default'
  },

  mutations
})
